export default __webpack_public_path__ + "static/media/volvo.91f58694.svg";